import { apiUrl } from "../../utils/constants";
import api from "../index";

export const GetTicketList = (params) => api.get(apiUrl.ticket, { params });
